import { ComponentProps, JSXElementConstructor } from 'react';

import AdModule from './AdModule';
import BlogSearchModule from './BlogSearchModule';
import ElectromobilityModule from './ElectromobilityModule';
import GenericModule from './GenericModule';
import ProductsModule from './ProductsModule';
import StepperModule from './StepperModule';

const SupportedModules = {
  GenericModule,
  AdModule,
  ElectromobilityModule,
  ProductsModule,
  StepperModule,
  BlogSearchModule,
};

export type Module = ComponentProps<(typeof SupportedModules)[keyof typeof SupportedModules]>;

export default function ModuleItem(props: Module) {
  const typeName = props.__typename.replace(/Record$/, '') as keyof typeof SupportedModules;
  const Component = typeName in SupportedModules && (SupportedModules[typeName] as JSXElementConstructor<unknown>);

  if (Component)
    return (
      <Component
        key={props.id}
        {...props}
      />
    );

  console.warn(' ✗ %s is not supported as a module type', typeName);
  return null;
}
